import { useState } from 'react';
import { useTracking } from 'react-tracking';
import loadable from '@loadable/component';
import { RegistrationOverlay, RegistrationButton } from './styled';
import { Text } from '@simplywallst/ui-core';

const GuestRegistrationModal = loadable(
  () => import(/* webpackPrefetch: true */ '@components/GuestRegistrationModal')
);

interface Props {
  id?: string;
}

const ChartRegistrationOverlay = ({ id }: Props) => {
  const [open, setOpen] = useState(false);
  const { trackEvent } = useTracking({ type: 'track' });
  return (
    <>
      <RegistrationOverlay
        templateColumns="200px"
        placeContent="center"
        placeItems="center"
        gap="8px"
        data-cy-id={`${id}-rego-overlay`}
      >
        <Text textAlign="center" typography="smallStrong">
          View full analysis with a free account
        </Text>
        <RegistrationButton
          data-cy-id="login-signup"
          styleType="louderLarge"
          marginTop={true}
          onClick={() => {
            setOpen(true);
            trackEvent({
              action: 'click',
              modifier: 'inlineRegistration',
              subject: 'guestRegistrationModal',
            });
          }}
        >
          Sign up for free
        </RegistrationButton>
      </RegistrationOverlay>
      {open && (
        <GuestRegistrationModal
          canClose={true}
          onClose={() => {
            trackEvent({
              subject: 'inlineRegistration',
              modifier: 'log_in_sign_up',
              action: 'close',
            });
            setOpen(false);
          }}
          onRegisterSuccess={() => {
            trackEvent({
              subject: 'inlineRegistration',
              modifier: 'registration',
              action: 'success',
            });
          }}
          onLoginSuccess={() => {
            trackEvent({
              subject: 'inlineRegistration',
              modifier: 'login',
              action: 'success',
            });
          }}
        />
      )}
    </>
  );
};

export default ChartRegistrationOverlay;
